// extracted by mini-css-extract-plugin
export default {"container":"TileSmallWithImgSection-module__container__NoR8M"};